module.exports = __webpack_public_path__ + "static/media/spa-header-text.7f608e12.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/appInvite/spa-header-text.png
// module id = 1846
// module chunks = 6